<template>
    <div class="a">
        <!-- 
        <div class="scroll-container" :class="{ 'scrolled': isScrolled }" :style="backgroundStyle">
            <div class="content" :style="textStyle">
                <h1>标题</h1>
                <p>随着滚动，背景将变为白色，文字将变为黑色，图片将替换。</p>
                <img :src="currentImage" alt="动态图片">
            </div>
        </div> -->

        <div class="topline scroll-container" :class="{ 'scrolled': isScrolled }" :style="backgroundStyle">
            <div class="topcenter">

                <!-- :src="currentImage"  src='../assets/logo1.png' -->
                <div class="logo"><img class="imgcss" :src="currentImage" alt="1"></div>
                <div class="textblock">

                    <!-- <div class="contentt" :style="textStyle" :class="{ 'texta': active == 1, 'textb': active !== 1 }"
                        @click="active = 1">
                        {{ this.$t('page.homepage.home') }}</div>
                    <div class="contentt" :style="textStyle" :class="{ 'texta': active == 2, 'textb': active !== 2 }"
                        @click="active = 2">
                        {{ this.$t('page.homepage.ac') }}</div>
                    <div class="contentt" :style="textStyle" :class="{ 'texta': active == 3, 'textb': active !== 3 }"
                        @click="active = 3">
                        {{ this.$t('page.homepage.aboutus') }}</div>
                    <div class="rcbtn"><img class="rcbtnimg" :src="currentImage2"  alt=""></div> -->
                </div>
            </div>
        </div>



        <div v-show="active == 1" class="topblock">
            <div class="midcenter">
                <!-- 两个灰色块 -->
                <!-- <div class="grayblock"></div> -->
                <!-- <div class="grayblock2"></div> -->
                <!-- <div class="grayblock"></div> -->
                <div class="midleft">

                    <!--  -->
                    <div class="andOrios">
                        <div class="jumpBox" @click="getUrl(2)">
                            <div class="iconimg">
                                <img class="imgapp"
                                    src="https://files.duku.live/static/activity/homepage/android@2x.png" alt="">
                            </div>
                            <div class="txt">Android</div>
                            <div class="flex1"></div>
                            <div class="rbtn">
                                <img class="imgapp" src="https://files.duku.live/static/activity/homepage/btn.png"
                                    alt="">
                            </div>
                        </div>
                        <div class="flex1"></div>
                        <div class="jumpBox" @click="getUrl(1)">
                            <div class="iconimg">
                                <img class="imgapp" src="https://files.duku.live/static/activity/homepage/apple@2x.png"
                                    alt="">
                            </div>
                            <div class="txt">Apple</div>
                            <div class="flex1"></div>
                            <div class="rbtn">
                                <img class="imgapp" src="https://files.duku.live/static/activity/homepage/btn.png"
                                    alt="">
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="midlefttop">{{ this.$t('page.homepage.title1') }}
                    </div>
                    <div class="midleftcenter">
                        {{ this.$t('page.homepage.detail1') }}
                    </div>
                    <div class="mlbottom">
                        <div class="cus">contact us: </div>


                        <!-- <div style="margin-right: 30px;" class="app"><img class="imgapp" src="../assets/app.png" alt="">
                        </div>
                        <div class="app"><img class="imgapp" src="../assets/android.png" alt=""></div> -->


                    </div>

                    <div class="white_pice">
                        <div class="wpimg"><img class="imgapp"
                                src="https://files.duku.live/static/activity/homepage/wsapp.png" alt=""></div>
                        <div class="wptxt">+852 6267 5478</div>
                    </div>

                    <div class="white_pice">
                        <div class="wpimg"><img class="imgapp"
                                src="https://files.duku.live/static/activity/homepage/email.png" alt=""></div>
                        <div class="wptxt">dukulive@outlook.com </div>
                    </div>

                  
                </div>
                <div class="midright">
                    <img class="imgapp" src="https://files.duku.live/static/activity/homepage/bigimg1.png" alt="">
                </div>
            </div>

        </div>



        <div v-show="active == 1" class="whiteblock1">
            <div class="circle1"><img class="imgapp" src="https://files.duku.live/static/activity/homepage/circle.png"
                    alt=""></div>

            <div class="banner">

                <!-- <div class="grayblock3"></div> -->
                <!-- <div class="grayblock4"></div> -->

                <div class="block1left">
                    <img class="imgapp" src="https://files.duku.live/static/activity/homepage/bigimg2.png" alt="">
                </div>

                <div class="block1right">

                    <div class="wjx">
                        <img class="imgapp" src="https://files.duku.live/static/activity/homepage/wjx.png" alt="">
                    </div>
                    <div class="vdlive">{{ this.$t('page.homepage.videolive') }}
                        <div class="circle2"><img class="imgapp"
                                src="https://files.duku.live/static/activity/homepage/circle.png" alt=""></div>
                    </div>
                    <div style="margin-top: 14px;" class="vdlive2">{{ this.$t('page.homepage.videolive1') }}</div>
                    <div class="vdlive2">{{ this.$t('page.homepage.videolive2') }}</div>
                    <div class="vdlive3">{{ this.$t('page.homepage.videolive3') }}</div>
                </div>
            </div>
        </div>
        <!-- ////////////////// -->
        <div v-show="active == 1" class="whiteblock2 whiteblock23">

            <div class="banner">

                <!-- <div class="grayblock5"></div> -->
                <!-- <div class="grayblock6"></div> -->



                <div class="block1right" style="margin-left: 105px;">

                    <div class="circlepk"><img class="imgapp"
                            src="https://files.duku.live/static/activity/homepage/circle.png" alt=""></div>
                    <div class="lcirclepk"><img class="imgapp"
                            src="https://files.duku.live/static/activity/homepage/circle.png" alt=""></div>
                    <div class="pwjx"><img class="imgapp"
                            src="https://files.duku.live/static/activity/homepage/pwjx.png" alt=""></div>


                    <div class="vdlive4">{{ this.$t('page.homepage.pk') }}</div>
                    <div style="margin-top: 14px;" class="vdlive2">{{ this.$t('page.homepage.pktext1') }}</div>
                    <div class="vdlive5">{{ this.$t('page.homepage.pktext2') }}</div>
                </div>
                <div class="block1left pkk">
                    <img class="imgapp" src="https://files.duku.live/static/activity/homepage/pk.png" alt="">
                </div>
            </div>
        </div>




        <div v-show="active == 1" class="whiteblock1">
            <div class="circle1"><img class="imgapp" src="https://files.duku.live/static/activity/homepage/circle.png"
                    alt=""></div>

            <div class="banner">

                <!-- <div class="grayblock7"></div> -->
                <!-- <div class="grayblock8"></div> -->

                <div class="block1left">
                    <img class="imgapp" src="https://files.duku.live/static/activity/homepage/bigimg3.png" alt="">
                </div>

                <div class="block1right">
                    <div class="wjx">
                        <img class="imgapp" src="https://files.duku.live/static/activity/homepage/pink.png" alt="">
                    </div>
                    <div class="vdlive8">{{ this.$t('page.homepage.vdparty') }}
                        <div class="circle2" style="right: -150px;"><img class="imgapp"
                                src="https://files.duku.live/static/activity/homepage/circle.png" alt=""></div>
                    </div>
                    <div style="margin-top: 14px; width: 500px;" class="vdlive2">{{ this.$t('page.homepage.vdpartyt1')
                    }}</div>
                    <div style="margin-top: 34px;" class="vdlive3">{{ this.$t('page.homepage.vdpartyt2') }}</div>
                </div>
            </div>
        </div>
        <!-- ////////////////// -->
        <!-- <div v-show="active == 1" class="whiteblock2">
          
            <div class="banner">

             


                <div class="block1right" style="margin-left: 105px;">
                    <div class="vdlive4">{{ this.$t('page.homepage.vcparty') }}</div>
                    <div class="vdlive2" style="margin-top: 20px;width: 390px;">{{ this.$t('page.homepage.vcpartyt1') }}</div>
                    <div class="vdlive5" style="margin-top: 60px;width: 390px;">{{ this.$t('page.homepage.vcpartyt2') }}</div>
                </div>
                <div class="block1left">
                    <img class="imgapp" src="../assets/phone5.png" alt="">
                </div>
            </div>
        </div> -->


        <!-- 第二页
  -->
        <div v-show="active == 2" class="topbg">
            <div class="centerp">
                <div class="centertwo">
                    <div class="centerimg"><img class="imgapp" src="../assets/app.png" alt=""></div>
                    <div class="centerimg"><img class="imgapp" src="../assets/android.png" alt=""></div>
                </div>

            </div>
        </div>



        <div v-show="active == 2" class="botmbox">

            <div class="botmbanner">
                <div class="btmtext1">{{ this.$t('page.homepage.page2text1') }}</div>
                <div class="bluepice"></div>
                <div class="btmtext2">{{ this.$t('page.homepage.page2text2') }}</div>
                <div class="btmtext3">{{ this.$t('page.homepage.page2text3') }}</div>
                <div class="text4box">
                    <div>Whatsapp:</div>
                    <div>
                        +91&nbsp;89820&nbsp;38463
                        +91&nbsp;95892&nbsp;64386
                        +91&nbsp;90391&nbsp;25554
                    </div>
                </div>

                <div class="btmbtn">
                    <div class="btntext">CONTACT&nbsp;US</div>

                </div>

            </div>
        </div>
        <div v-show="active == 3" class="topbg3">
            <div class="centerp">
                <div class="centertwo">
                    <div class="centerimg"><img class="imgapp" src="../assets/app.png" alt=""></div>
                    <div class="centerimg"><img class="imgapp" src="../assets/android.png" alt=""></div>
                </div>

            </div>
        </div>



        <div v-show="active == 3" class="botmbox2">


            <div class="info">
                {{ this.$t('page.homepage.page3text1') }}
                <!-- Joyo Live is a live streaming platform. We are dedicated to connecting friends from all over the world,
                creating a platform for showcasing talents, having fun, and interacting. We aim to help ordinary people
                fulfill their dreams of becoming stars. -->
            </div>
            <div class="botmbanner">
                <!-- <div class="btmtext1">CONTACT&nbsp;US</div>
        <div class="bluepice"></div>
        <div class="btmtext2">New&nbsp;Agency&nbsp;Cooperation</div> -->
                <div class="btmtext3">{{ this.$t('page.homepage.page2text3') }} </div>
                <div class="text4box">
                    <div>Whatsapp:</div>
                    <div>
                        +91&nbsp;89820&nbsp;38463
                        +91&nbsp;95892&nbsp;64386
                        +91&nbsp;90391&nbsp;25554
                    </div>
                </div>

                <div class="btmbtn">
                    <div class="btntext">CONTACT&nbsp;US</div>

                </div>

            </div>
        </div>




        <!-- <div class="bottom">
            <div class="bannerbottom">
                <div class="bottomlogo"><img class="imgapp" src="../assets/logo2.png" alt=""></div>

                <div class="bottomright">
                    <div class="rtext">{{ this.$t('page.homepage.flus') }}</div>

                    <div class="botimg"><img class="imgapp" src="../assets/face.png" alt="">
                    </div>
                    <div class="botimg"><img class="imgapp" src="../assets/ins.png" alt=""></div>

                </div>
            </div>

        </div> -->

    </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import md5 from 'js-md5'
import axios from 'axios'
export default {
    name: 'HomePage',
    data() {
        return {
            msg2: 'Welcome to Your Vue.js App',
            active: 1,

            scrollPosition: 0,
            scrollThreshold: 100, // 滚动开始变化的阈值
            isScrolled: false,
            backgroundColor: 'rgba(255, 255, 255, 0)', // 初始背景色（透明）
            textColor: '#ffffff', // 初始文字颜色（白色）
            defaultImage: 'https://files.duku.live/static/activity/homepage/logo@2x.png', // 默认图片路径
            scrolledImage: 'https://files.duku.live/static/activity/homepage/logo@2x.png', // 滚动后图片路径
            currentImage: 'https://files.duku.live/static/activity/homepage/logo@2x.png', // 当前显示的图片路径
            defaultImage2: '../assets/rechargebtn.png', // 默认图片路径
            scrolledImage2: require('../assets/black_recharge.png'), // 滚动后图片路径
            currentImage2: require('../assets/rechargebtn.png'), // 当前显示的图片路径
        }
    },
    props: {
        msg: String
    },
    mounted() {
        this.currentImage = this.defaultImage; // 初始化图片
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
        backgroundStyle() {
            // 根据滚动位置计算背景色透明度
            const opacity = Math.min(1, this.scrollPosition / window.innerHeight);
            return {
                backgroundColor: `rgba(255, 255, 255, ${opacity.toFixed(2)})`,
            };
        },
        textStyle() {
            // 根据是否滚动决定文字颜色
            return {
                color: this.isScrolled ? '#000000' : this.textColor,
            };
        },
    },
    methods: {
        encrypto (word) {
        let key = '';
        if (process.env.NODE_ENV != 'production') {
          key = 'asD72S7fJ9qw261D'
        } else {
          key = 'asD72S7fJ9qw261D'
        }
        let iv = '1234567812345678';

        key = CryptoJS.enc.Utf8.parse(key);
        iv = CryptoJS.enc.Utf8.parse(iv);

        let srcs = CryptoJS.enc.Utf8.parse(word);
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
        getSign (obj) {
        let signKey = "";
        if (process.env.NODE_ENV != 'production') {
          signKey = 'ASDasd8KD72njkaDFh8934jnNKW3b3'
        } else {
          signKey = 'ASDasd8KD72njkaDFh8934jnNKW3b3'
        }

        // if (obj.package_type == undefined && this.$route.query.package_type != undefined) {
        //     obj.package_type = this.$route.query.package_type
        // }

        obj.time = timest()
        let sign = sortSign(obj);
        let sign_obj = {sign: sign};
        let new_data = Object.assign(sign_obj, obj);
        return new_data;

        //sign排序
        function sortSign(obj) {
          var newkey = Object.keys(obj).sort();
          let sign = "";
          var newObj = {};
          for (var i = 0; i < newkey.length; i++) {
            sign += newkey[i] + "=" + obj[newkey[i]] + "&";
            newObj[newkey[i]] = obj[newkey[i]];
          }
          sign = sign + "key=" + signKey;
          // console.log(sign);
          
          return md5(sign); //返回排好序的新对象
        }
        function timest() {
          var tmp = Date.parse(new Date()).toString();
          tmp = tmp.substr(0, 10);
          if(getUrlParam('time_diff') || window.sessionStorage.getItem('timeDiff')){
            let time_diff = getUrlParam('time_diff') || window.sessionStorage.getItem('timeDiff')
            return Math.abs(time_diff) <=5 ? tmp : Number(tmp) - Number(time_diff);
          }
          return tmp;
        }
        function getUrlParam(name) {
          var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
          var r = window.location.search.substr(1).match(reg);
          if (r != null) return unescape(r[2]); return null;
        }
    },
        getUrl(deviceType) {
    //   if (this.deviceObj.deviceType == 3) this.deviceObj.deviceType = 2;
      let qsData = {
        package_type: deviceType == 1 ? 51 : 11
      };
      let data = this.getSign(qsData);
      let param = this.encrypto(JSON.stringify(data))


     axios
          .post("https://h5.duku.live/api/H5version/appUrl", { params: param })
          .then(res => {
            let respose = res.data.data;
            if (res.data.code == 0) {
              this.qrUrl = respose.download_url
              window.location.href = this.qrUrl
            } else {
              this.$vux.toast.text(res.data.message);
            }
          })
        //   .catch(error => {
        //     that.$vux.loading.hide();
        //     that.$vux.alert.show({content: "系统异常"});
        //   });
    },
        handleScroll() {
            this.scrollPosition = window.scrollY;
            this.isScrolled = this.scrollPosition > this.scrollThreshold;
            if (this.isScrolled) {
                this.currentImage = this.scrolledImage; // 替换图片
                this.currentImage2 = this.scrolledImage2; // 替换图片
            } else {
                this.currentImage = this.defaultImage; // 恢复默认图片
                this.currentImage2 = this.defaultImage2; // 恢复默认图片
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    margin: 0px;
    padding: 0px;
}

body {
    margin: 0px !important;
    padding: 0px;

}

.topblock {
    width: 100%;
    height: 900px;
    background-image: url(https://files.duku.live/static/activity/homepage/banner_bg@2x.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    overflow: hidden;

}

.topline {
    width: 100%;
    height: 111px;
    position: fixed;
    top: 0px;
    z-index: 999;
    /* background: white;  */
}

.topcenter {
    margin: 0 auto;
    width: 1200px;
    height: 111px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    width: 183px;
    height: 49px;
}

.imgcss {
    transition: opacity 0.5s ease;
    /* 添加图片淡入淡出效果（如果需要） */
    width: 100%;
    height: 100%;
}

.textb {
    cursor: pointer;
    margin-right: 60px;
    height: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.5);
    line-height: 33px;
    text-align: right;
    font-style: normal;
}

.texta {
    position: relative;
    cursor: pointer;
    margin-right: 60px;
    height: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 33px;
    text-align: right;
    font-style: normal;
}

.texta::before {
    content: '';
    /* 伪元素需要内容，但这里我们不需要显示任何内容 */
    width: 28px;
    height: 4px;
    background: #FFFFFF;
    border-radius: 3px;
    position: absolute;
    top: 100%;
    /* 将其放置在父元素的底部 */
    left: 50%;
    /* 水平居中（需要配合transform） */
    transform: translateX(-50%);
    /* 水平居中 */
}

.textblock {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.rcbtn {
    width: 140px;
    height: 47px;
    cursor: pointer;
}

.rcbtnimg {
    width: 100%;
    height: 100%;
}

.midlefttop {
    width: 638px;
    height: 140px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 65px;
    color: #000000;
    line-height: 70px;
    text-align: left;
    font-style: normal;
}

.midleftcenter {
    margin-top: 31px;
    width: 577px;
    height: 33px;
    margin-left: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    line-height: 33px;
    text-align: left;
    font-style: normal;

}

.midcenter {
    position: relative;
    margin: 0 auto;
    width: 1200px;
    /* height: 111px; */
    display: flex;
    justify-content: space-between;
}

.mlbottom {
    width: 638px;
    height: 40px;
    margin-top: 50px;
    margin-left: 30px;
    display: flex;
    justify-content: left;
    align-items: left;

}

.app {
    width: 123px;
    height: 40px;
    cursor: pointer;
}

.imgapp {
    width: 100%;
    height: 100%;
}

.midright {
    width: 700px !important;
    height: 705px;
    margin-top: 205px;
    position: absolute;
    right: 0px;
    top: -40px;
}

.midleft {
    margin-top: 292px;
    position: relative;
    flex: 1
}

.whiteblock1 {
    width: 100%;
    height: 960px;
    /* background-image: url(../assets/bg1.png); */
    /* background-repeat: no-repeat;
    background-size: 100% 100%; */
    position: relative;

}

.circle1 {
    width: 161px;
    height: 161px;
    position: absolute;
    top: 566px;
    left: 50%;
}

.circle2 {
    width: 80px;
    height: 80px;
    position: absolute;
    top: -50px;
    right: -100px;
}

.whiteblock2 {
    width: 100%;
    height: 960px;
    background-image: url(../assets/bg3.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.whiteblock3 {
    width: 100%;
    height: 980px;
}

.whiteblock4 {
    width: 100%;
    height: 980px;
}

.grayblock {
    position: absolute;
    left: -32px;
    top: 424px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock3 {
    position: absolute;
    left: -32px;
    top: 225px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock7 {
    position: absolute;
    left: -32px;
    top: 526px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock8 {
    position: absolute;
    left: 1200px;
    top: 526px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock9 {
    position: absolute;
    left: -32px;
    top: 490px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock10 {
    position: absolute;
    left: 1200px;
    top: 490px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock4 {
    position: absolute;
    left: 1200px;
    top: 225px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock5 {
    position: absolute;
    left: -32px;
    top: 285px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.grayblock6 {
    position: absolute;
    left: 1200px;
    top: 285px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}


.grayblock2 {
    position: absolute;
    left: 1200px;
    top: 424px;
    z-index: 888;
    width: 32px;
    height: 70px;
    background: #D8D8D8;
    border-radius: 8px;
}

.banner {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

}

.block1left {
    width: 579px;
    height: 910px;
    margin-top: 53px;
}

.vdlive {
    white-space: nowrap;
    position: relative;
    width: 279px;
    height: 78px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 56px;
    color: #333333;
    line-height: 78px;
    text-align: left;
    font-style: normal;
    margin-top: 322px;
    margin-right: 195px;
    z-index: 888;
}

.vdlive::before {
    position: relative;
    content: '';
    /* 伪元素需要内容，但这里我们不需要显示任何内容 */
    width: 295px;
    height: 20px;
    background: #B4EF4E;
    border-radius: 8px;
    position: absolute;
    top: 73%;
    /* 将其放置在父元素的底部 */
    left: 53%;
    /* 水平居中（需要配合transform） */
    transform: translateX(-50%);
    z-index: -20;
    /* 水平居中 */
}

.vdlive8 {
    white-space: nowrap;
    position: relative;
    width: 279px;
    height: 78px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 56px;
    color: #333333;
    line-height: 78px;
    text-align: left;
    font-style: normal;
    margin-top: 322px;
    margin-right: 195px;
    z-index: 888;
}

.vdlive8::before {
    content: '';
    /* 伪元素需要内容，但这里我们不需要显示任何内容 */
    width: 320px;
    height: 20px;
    background: #B4EF4E;
    border-radius: 8px;
    position: absolute;
    top: 73%;
    /* 将其放置在父元素的底部 */
    left: 58%;
    /* 水平居中（需要配合transform） */
    transform: translateX(-50%);
    z-index: -20;
    /* 水平居中 */
}

.vdlive4 {
    white-space: nowrap;
    position: relative;
    width: 279px;
    height: 78px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 56px;
    color: #333333;
    line-height: 78px;
    text-align: left;
    font-style: normal;
    margin-top: 322px;
    margin-right: 195px;
    z-index: 888;
}

.vdlive4::before {
    content: '';
    /* 伪元素需要内容，但这里我们不需要显示任何内容 */
    width: 395px;
    height: 20px;
    background: #B4EF4E;
    border-radius: 8px;
    position: absolute;
    top: 73%;
    /* 将其放置在父元素的底部 */
    left: 73%;
    /* 水平居中（需要配合transform） */
    transform: translateX(-50%);
    z-index: -20;
    /* 水平居中 */
}

.vdlive2 {

    word-break: break-all;
    /* width: 389px;
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #333333;
    line-height: 36px;
    text-align: left;
    font-style: normal; */

    width: 447px;
    height: 45px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 32px;
    color: #333333;
    line-height: 45px;
    text-align: left;
    font-style: normal;
}

.vdlive3 {
    margin-top: 34px;
    width: 399px;
    height: 66px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #999999;
    line-height: 33px;
    text-align: left;
    font-style: normal;
}

.vdlive5 {
    margin-top: 34px;

    width: 450px;
    height: 66px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #999999;
    line-height: 33px;
    text-align: left;
    font-style: normal;
}

.bottomlogo {
    width: 176px;
    height: 49px;
}

.bottom {
    width: 100%;
    height: 172px;
}

.bannerbottom {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 27px;

}

.rtext {
    height: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #333333;
    line-height: 33px;
    text-align: left;
    margin-top: 8px;
    margin-right: 20px;
    font-style: normal;
    cursor: pointer;
}

.bottomright {
    width: 250px;
    display: flex;
    justify-content: space-between;
}

.botimg {
    width: 40px;
    height: 40px;
    cursor: pointer;
    transition: width 0.3s ease, height 0.3s ease;
    /* 添加过渡效果 */
}

.botimg:hover {
    width: 50px;
    height: 50px;
}


.box {
    width: 100%;
    overflow: hidden;

}

.topbg {
    overflow: hidden;

    width: 100%;
    height: 859px;
    background: url("../assets/banner2.png") no-repeat center center;
    background-size: cover;
}

.topbg3 {
    overflow: hidden;

    width: 100%;
    height: 859px;
    background: url("../assets/box3bg.png") no-repeat center center;
    background-size: cover;
}

.centerp {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 569px;
    overflow: hidden;

}

.centertwo {
    width: 276px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

}

.centerimg {
    width: 123px;
    height: 40px;
}

.imgapp {
    width: 100%;
    height: 100%;
}

.botmbox {
    width: 100%;
    height: 874px;
    background: url("../assets/bg2.png") no-repeat center center;
    background-size: cover;
}

.botmbox2 {
    width: 100%;
    height: 674px;
    background: url("../assets/bg2.png") no-repeat center center;
    background-size: cover;
}

.btmtext1 {
    height: 46px;
    font-family: Geometric415BT, Geometric415BT;
    font-weight: normal;
    font-size: 38px;
    color: #333333;
    line-height: 46px;
    text-align: left;
    font-style: normal;
}

.botmbanner {
    width: 450px;
    margin-left: 40%;
    margin-top: 70px;
}

.bluepice {
    margin-top: 20px;
    width: 125px;
    height: 8px;
    background: linear-gradient(224deg, #5D86FF 0%, #8623FF 100%);
    border-radius: 7px;
}

.btmtext3 {
    height: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #999999;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    margin-top: 40px;
}

.btmtext2 {
    height: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 28px;
    color: #666666;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    margin-top: 20px;
}

.text4box {
    width: 440px;
    height: 120px;
    margin-top: 30px;
    display: flex;

    /* width: 439px;
height: 117px; */
    font-family: Geometric415BT, Geometric415BT;
    font-weight: normal;
    font-size: 32px;
    color: #333333;
    line-height: 39px;
    text-align: left;
    font-style: normal;
}

.btmbtn {
    margin-top: 30px;
    width: 448px;
    height: 81px;
    background: linear-gradient(224deg, #5D86FF 0%, #8623FF 100%);
    border-radius: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contentt {
    transition: color 0.5s ease;
    /* 添加文字颜色过渡效果 */
}

.btntext {
    width: 159px;
    height: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 33px;
    text-align: center;
    font-style: normal;
}

.info {
    width: 1129px;
    height: 168px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #333333;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 29px auto;
    margin-bottom: 8px;
}

.scroll-container {
    transition: background-color 0.5s ease;
    /* 添加背景色过渡效果 */
}

.cus {
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.white_pice {
    margin-top: 20px;
    width: 280px;
    height: 60px;
    padding-left: 20px;
    box-sizing: border-box;
    padding-top: 14px;
    background: #FFFFFF;
    display: flex;
    border-radius: 30px 30px 30px 30px;
}

.wpimg {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.wptxt {
    flex: 1;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 60px;
    position: relative;
    top: -15px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.block1right {
    position: relative;
}

.wjx {
    width: 256px;
    height: 256px;
    border-radius: 0px 0px 0px 0px;
    /* opacity: 0.7; */
    /* filter: blur(46.2400016784668px); */
    position: absolute;
    top: 700px;
    left: 400px;
}

.pwjx {
    width: 256px;
    height: 256px;
    border-radius: 0px 0px 0px 0px;
    /* opacity: 0.7; */
    /* filter: blur(46.2400016784668px); */
    position: absolute;
    top: 580px;
    left: -150px;
}

.circlepk {
    width: 80px;
    height: 80px;
    position: absolute;
    right: -600px;
    bottom: 0px;
}

.lcirclepk {
    width: 161px;
    height: 161px;
    position: absolute;
    left: -130px;
    top: 89px;
}

.pkk {
    width: 470px;
    height: 800px;
    position: relative;
    left: -60px;
}

.whiteblock23 {
    /* width: 1920px; */
    /* height: 960px; */
    background: rgba(180, 239, 78, 0.1);
    border-radius: 0px 0px 0px 0px;
}

.andOrios {
    width: 512px;
    display: flex;
    justify-content: space-between;
position: absolute;top: -100px;

}

.iconimg {
    width: 32px;
    height: 32px;
    margin-right: 12px;
}

.jumpBox {
    cursor: pointer;
    width: 240px;
    height: 60px;
    border-radius: 30px;
    padding-top: 14px;
    padding-left: 20px;
    padding-right: 8px;
    box-sizing: border-box;
    display: flex;
    background: #FFFFFF;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.flex1 {
    flex: 1
}

.rbtn {
    width: 44px;
    height: 44px;
    position: relative;
    top: -6px;
}
</style>